import styled, { css } from 'styled-components';

import { Frame, H1, RowWrapper, TExtra } from 'components/StyledTemplates/StyledTemplates';

import theme from 'constants/theme-constants';

import { convertHex } from 'utils/colors-helper';

import imgCheck from 'assets/check.svg';
import imgIconsDownloadDocuments from 'assets/icons/download-documents.png';
import imgIconsMobileMenuDropdownArrow from 'assets/icons/mobile-menu-dropdown-arrow.svg';
import imgIconsMoreVertDark from 'assets/icons/more-vert-dark.svg';
import imgLegacyLeaves from 'assets/legacy-leaves.svg';

export const Divider = styled(Frame)<{ extended?: boolean }>`
    width: 100%;
    height: 0px;
    border-top: 1px solid #ede6dc;
    margin: 25px 0;

    ${(props: any = {}) => (props.extended ? `width: calc(100% + 50px);` : ``)}
    ${(props: any = {}) => props?.extra}
`;

export const SupportHeading = styled(H1)<{ extra?: string }>`
    margin: 0 !important;
    font-size: 17px !important;
    line-height: 21px !important;
    text-align: center;

    ${({ extra = '' }) => extra}
`;

export const NotificationsPlate = styled(Frame)<{ extra?: string; key?: number }>`
    width: 100%;
    padding: 10px 23px;
    border: 1px solid #e3e3e3;
    border-radius: 6px;
    flex-direction: row;
    margin-bottom: 10px;

    @media (min-width: 768px) {
        > * {
            &:nth-child(1) {
                flex: 5;
                align-items: flex-start;
            }
            &:nth-child(2) {
                text-align: center;
                flex: 1;
            }
            &:nth-child(3) {
                flex: 1;
            }
            &:nth-child(4) {
                flex: 1;
            }
        }
    }

    ${(props: any = {}) => props.extra}

    @media (max-width: 768px) {
        padding: 14px 17px;
        flex-direction: column;
        > * {
            width: 100%;
            align-items: flex-start;
        }
    }
`;

export const NotificationsPlateHeader = styled(NotificationsPlate)`
    border: 0;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const DocumentNameFrame = styled(Frame)`
    font-weight: 600;
    font-size: 17px;
    line-height: 23px;

    display: block;
    width: 430px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 768px) {
        color: #484848;
        max-width: 80vw;
    }
`;

export const RoleFrame = styled(Frame)`
    flex-direction: row;
    /*font-family: Open Sans;*/
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 23px;

    > * {
        &:nth-child(2) {
            font-weight: 700;
            margin-left: 5px;
        }
    }

    @media (max-width: 768px) {
        font-weight: 400;
        /*font-family: Marcellus, serif;*/
        font-size: 14px;
        line-height: 22px;
        color: #484848;

        > * {
            &:nth-child(2) {
                font-weight: 400;
            }
        }
    }
`;

export const StatusFrame = styled(Frame)`
    @media (max-width: 768px) {
        display: none;
    }
`;

export const CheckFrame = styled(Frame)`
    @media (max-width: 768px) {
        display: none;
    }
`;

export const NotifiedAndSharedFrame = styled(Frame)`
    align-items: flex-end;
    font-size: 13px;
    line-height: 18px;
    font-weight: 600;
    color: #383838;

    @media (min-width: 768px) {
        display: none;
    }
`;

export const NotifyShareRow = styled(Frame)<{ extra?: string }>`
    flex: 2 !important;
    flex-direction: row;
    justify-content: flex-start;

    @media (max-width: 768px) {
        margin-top: 20px;
    }

    ${(props: any) => props.extra}
`;

export const CheckboxUpdateFrame = styled(Frame)`
    justify-content: flex-end;
    flex-direction: row;
    margin-right: 30px;
    width: 100%;

    > span {
        display: none;
    }

    @media (max-width: 768px) {
        justify-content: flex-start;
        width: auto;
        /*font-family: Marcellus, serif;*/
        line-height: 14px;

        &:last-child {
            margin-right: 0;
        }

        > span {
            padding-right: 14px;
            display: inline-block;
        }
    }
`;

export const Check = styled(Frame)<{ extra?: string }>`
    width: 21px;
    height: 21px;
    background: url('${imgCheck}') no-repeat center center / contain;
`;

export const RightColumnTopTabsWrapper = styled(Frame)<{ extra?: string; visibleItemsNumber?: number }>`
    width: 100%;
    flex-direction: row;
    justify-content: ${({ visibleItemsNumber = 0 }) => (visibleItemsNumber === 0 ? 'flex-end' : 'space-between')};
    align-items: flex-start;
    /*font-family: Open Sans;*/
    gap: 10px;

    > * {
        width: calc(100% / ${({ visibleItemsNumber = 0 }) => visibleItemsNumber + 1});
        flex: 1;
        align-items: flex-start;

        > * {
            &:nth-child(1) {
                font-weight: 600;
            }
            &:nth-child(2) {
                width: 100%;
                > * {
                    display: block;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    width: 100%;
                    /* prettier-ignore */
                    max-width: calc((100vw - 270px - 30px - 60px - 150px - 120px - 150px) / ${({
                        visibleItemsNumber = 1,
                    }) => visibleItemsNumber});
                }
            }
        }
    }

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 0 15px;
        color: #414141;

        > * {
            width: 100%;
            margin-bottom: 10px;
            > * {
                &:nth-child(1) {
                    font-weight: 700;
                }

                &:nth-child(2) {
                    > * {
                        max-width: calc(100vw - 74px);
                    }
                }
            }
        }
    }
`;

export const MenuItem = styled(Frame)<{ extra?: string; selected?: boolean; $openedOnMobile?: boolean }>`
    /*font-family: Open Sans;*/
    font-size: 16px;
    cursor: pointer;
    background: ${({ theme, selected }) => (selected ? theme.primary_action : '#EAE5DD')};
    color: ${({ selected }) => (selected ? 'white' : '#655D5D')};
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    &:before {
        content: '';
        width: 37px;
        height: 20px;
        margin-right: 14px;
        border-radius: 50%;
    }

    &:hover {
        background: ${(props: any = {}) => convertHex(props.theme.primary_action, props.selected ? 1 : 0.05)};
        color: ${(props: any = {}) => (props.selected ? 'white' : '#655D5D')};
    }

    * {
        color: ${(props: any = {}) => (props.selected ? `white` : '#655D5D')} !important;
    }

    @media (max-width: 991px) {
        background: ${(props: any = {}) => (props.selected ? props.theme.primary_action : 'transparent')};

        ${({ $openedOnMobile = false }: any) =>
            !$openedOnMobile &&
            css`
                opacity: 0;
                height: 0;
                padding: 0 !important;
                transform: translateX(100%);
            `}
    }
`;

interface MenuBlockHeaderProps {
    icon?: string;
    $opened?: boolean;
    selectable?: boolean;
    selected?: boolean;
    extra?: TExtra;
    $hideArrow?: boolean;
    ['data-qaid']?: string;
}

export const MenuBlockHeader = styled(H1)<MenuBlockHeaderProps>`
    padding: 2px 26px !important;
    font-size: 17px;
    background: #e8e0d3;
    margin: 0 !important;

    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: default;

    ${({ selectable = false, selected = false }: any) =>
        selectable &&
        css`
            background: ${selected ? '#EAE5DD' : theme.primary_action};
            color: ${selected ? `#655D5D` : `white`};

            &:hover {
                background: ${convertHex('#EAE5DD', selected ? 1 : 0.05)};
                color: #655d5d;
            }

            * {
                color: ${selected ? `#655D5D` : `white`} !important;
            }
        `}

    &:before {
        content: '';
        width: 37px;
        height: 37px;
        margin-right: 14px;
        border-radius: 50%;
        /* background: ${({ theme }) => theme.primary_action}; */
        background: url(${({ icon }) => icon}) no-repeat center center / contain;
    }

    ${({ selectable = false }: any) =>
        !selectable &&
        css`
            @media (max-width: 991px) {
                background: transparent;
                width: 100%;
                justify-content: flex-start;
                margin: 16px 0 !important;
            }
        `}

    ${({ selectable = false, $opened, $hideArrow = false }: any) =>
        !selectable &&
        !$hideArrow &&
        css`
            @media (max-width: 991px) {
                &:after {
                    content: '';
                    width: 15px;
                    height: 7.5px;
                    background: url('${imgIconsMobileMenuDropdownArrow}') no-repeat center center / contain;
                    margin-left: auto;
                    transition: 0.2s;
                    transform: ${$opened ? `rotate(180deg)` : `rotate(0deg)`};
                }
            }
        `}

    ${({ selectable = false, selected = false }) => selectable && !selected && `cursor: pointer;`}

    ${({ extra }: any) => extra}
`;

export const MenuBlockLinkHeader = styled(MenuBlockHeader)`
    cursor: pointer;
`;

export const MenuBlock = styled(Frame)<{ extra?: string }>`
    /* border-radius: 11px; */
    overflow: hidden;
    background: #efebe4;
    /* margin-bottom: 20px; */
    width: 100%;

    > * {
        /* width: 270px; */
        width: 100%;
        padding: 16px 26px;
    }

    @media (max-width: 991px) {
        background: #faf9f8;
    }
`;

const ScrollableDashboardElement = styled.div<{ extra?: string; scrollbarVisible?: any; anyChildren?: boolean }>`
    display: block;
    max-height: calc(100vh - 70px - 120px);
    overflow-x: clip;
    overflow-y: scroll;
    ${({ anyChildren = true }: any) => anyChildren && `padding: 30px 0;`}

    &:not(&:hover) {
        scrollbar-width: none;
        &::-webkit-scrollbar-thumb {
            background: transparent;
        }
    }
    /* &::-webkit-scrollbar {
        width: 0px;
    } */
`;

export const LeftColumn = styled(ScrollableDashboardElement)<{ extra?: string }>`
    width: 280px;
    min-width: 280px;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;

    ${(props: any) => props.extra}
`;

export const RightColumn = styled(ScrollableDashboardElement)<{ extra?: string }>`
    width: 100%;
    padding-left: 30px;
    margin-left: 280px;

    ${(props: any) => props.extra}
`;

export const Workspace = styled(Frame)<{ extra?: string }>`
    width: 100%;
    /* margin-top: 90px; */

    ${(props: any) => props.extra}
`;

export const Wrapper = styled(Frame)<{ extra?: string }>`
    width: 96vw;
    max-width: 1200px;
    /* margin-bottom: 50px; */
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    max-height: calc(100vh - 120px - 70px);
    overflow: hidden;

    /* > * {
        width: 100%;
        flex: 1;
        align-items: flex-start;
    } */
`;

export const MoreButton = styled(Frame)<{ extra?: string }>`
    cursor: pointer;
    &:hover {
        opacity: 0.5;
    }
    &:after {
        content: '';
        width: 30px;
        height: 30px;
        background: url('${imgIconsMoreVertDark}') no-repeat center center / contain;
    }
`;

export const AssignedRolesText = styled(Frame)<{ extra?: string; lower?: boolean }>`
    /*font-family: Open Sans;*/
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    margin-right: 15px;

    ${(props: any) =>
        props.lower &&
        css`
            font-size: 14.5px;
            line-height: 22px;
            text-decoration-line: underline;
            cursor: pointer;
        `}
`;

export const ReferTabWrapper = styled(Frame)<{ extra?: string }>`
    padding: 18px 18px 38px 18px;
    box-sizing: border-box;
    background: ${() => convertHex(`#FFFFFF`, 0.3)};
    border-radius: 16px;
    margin-top: 20px;
    width: calc(100% - 12px);

    * {
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        color: #655d5d;
    }
`;

export const LegacyLeaves = styled(Frame)<{ extra?: string }>`
    width: 22px;
    height: 22px;
    background: url('${imgLegacyLeaves}') no-repeat center center / contain;
`;

export const EmailInput = styled.input<{ extra?: string }>`
    height: 39px;
    background: #e7e7e7;
    border-radius: 5px 0 0 5px;
    width: calc(100% - 66px);
    text-align: left;
    outline: none;
    padding: 8px 16px;
    box-sizing: border-box;
    border: 0px;
`;

export const ReferButton = styled(Frame)<{ extra?: string; disabled?: boolean }>`
    width: 66px;
    height: 39px;
    background: ${(props: any) => props.theme.primary_action};
    border-radius: 0 5px 5px 0;
    color: white;
    font-weight: 600;
    font-size: 14px;
    line-height: 37px;
    cursor: pointer;
    outline: none;

    ${({ disabled = false }: any) =>
        disabled &&
        css`
            opacity: 0.5;
            cursor: not-allowed;
        `}
`;

export const ReferInputAndButtonWrapper = styled(Frame)<{ extra?: string }>`
    flex-direction: row;
    margin-top: 15px;
`;

export const Document = {
    Card: styled.div<{ headerColor: string }>`
        width: 193px;
        height: 198px;
        background: #ffffff;
        border: 1px solid #dfdfdf;
        border-radius: 5px 5px 8px 8px;
        border-top: 5px solid;
        border-top-color: ${({ headerColor }) => headerColor};
        padding: 26px 17px 17px 21px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        cursor: pointer;
    `,

    Name: styled.div<{ extra?: string }>`
        /*font-family: Open Sans;*/
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: #000000;

        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
        max-height: calc(22px * 4);
        overflow: hidden;

        ${({ extra = '' }) => extra}
    `,
    Description: styled.div<{ extra?: string }>`
        /*font-family: Open Sans;*/
        font-size: 14px;
        line-height: 17px;
        color: #6c757d;

        ${({ extra = '' }) => extra}
    `,
    ScansButton: styled.div<{ extra?: string }>`
        font-size: 16px;
        line-height: 16px;
        color: #655d5d;
        margin-top: 5px;
        cursor: pointer;

        text-decoration: underline;
        font-size: 14px;

        flex-direction: row;
        display: flex;
        gap: 0.5rem;

        width: min-content;
        align-items: center;

        &:before {
            content: '';
            width: 14px;
            height: 14px;
            background: url('${imgIconsDownloadDocuments}') no-repeat center center / contain;
            display: flex;
            flex-shrink: 0;
        }

        &:hover {
            background: #00000010;
            border-radius: 0.25rem;
        }
    `,
    DropdownWrapper: styled.div<{ extra?: string }>`
        position: absolute;
        bottom: 18px;
        right: 7px;
    `,
};

export const DocumentsGrid = styled(RowWrapper)<{ extra?: string }>`
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 29px;
    justify-content: flex-start;

    @media (max-width: 576px) {
        justify-content: space-around;
    }
`;

export const DocumentsSectionHeader = styled(RowWrapper)<{ extra?: string }>`
    margin-bottom: 21px;
    /*font-family: Open Sans;*/
    font-weight: bold;
    font-size: 18px;
    line-height: 30px;
    color: #494848;
    border-bottom: 1px solid rgba(108, 117, 125, 0.3);
    padding-bottom: 8px;
`;

export const DocumentsSectionName = styled(Frame)`
    font-family: 'Marcellus', serif;
    font-size: 28px;
    line-height: 30px;

    @media (max-width: 476px) {
        font-size: 24px;
        line-height: 20px;
    }
`;

export const DashboardStyles = {
    Wrapper: styled(Frame)<{ extra?: string }>`
        width: 100%;
        height: 100%;
        /* margin-top: -24px; */
        flex-direction: row;
        align-items: flex-start;
    `,
    MenuWrapper: styled(Frame)<{ extra?: string }>`
        min-height: calc(100vh - 70px);
        justify-content: flex-start;
        display: flex;
        overflow: auto;
        width: 280px;
        background: #efebe4;
        justify-content: space-between;
        overflow-x: hidden;

        position: sticky;
        top: 70px;

        ${({ extra = '' }) => extra}
    `,
    MenuInnerWrapper: styled(Frame)`
        display: flex;
        min-height: min-content;
        width: 100%;
        > * {
            &:first-child {
                > * {
                    &:first-child {
                        padding-top: 10px !important;
                    }
                }
            }
        }
    `,
    WorkspaceWrapper: styled(Frame)`
        width: 100%;
        min-height: calc(100vh - 70px - 83px);
        justify-content: flex-start;
        flex: 1;
        display: flex;
    `,
    WorkspaceWrapperAdvisorClient: styled(Frame)`
        width: 100%;
        min-height: calc(100vh - 70px - 83px);
        justify-content: flex-start;
        flex: 1;
        display: flex;
        margin-left: 390px;
        align-items: flex-start;
        padding-left: 100px;
    `,
    WorkspaceInnerWrapper: styled(Frame)`
        display: flex;
        min-height: min-content;
        width: 100%;
        max-width: 900px;
        padding: 0 10px;
        box-sizing: border-box;
        > * {
            width: 100%;
        }
    `,
    CompletedPlanBar: styled(Frame)`
        padding: 16px 72px 19px 52px;
        background-color: #3c5d30;
        width: 100%;
        flex-direction: row;
        z-index: 2;
        position: absolute;
        top: 70px;

        @media (max-width: 991px) {
            padding: 16px 20px 19px 20px;
        }
    `,
};

export const UpdateEstatePlanButton = styled(Frame)<{ extra?: string }>`
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 27px;
    text-decoration-line: underline;
    color: #ffffff;
    cursor: pointer;
`;
